const conf_ID = 10072;

// load what papers that I like from CHI 2022
const fetchLikedContent = async (soya_token) => {
    let author_url = `https://api.sigchi.org/api/cloud/external/read/all`;
             
              return fetch(author_url, {
                  method: 'POST',
                  body: JSON.stringify({ lastSyncDate: 0 }),
                  headers: {
                      "Sigchi-User-Token": soya_token,
                      "Public-App-Signature": "client: Name, app: 1.0",
                      'Content-Type': 'application/json',
                      // 'Content-Type': 'application/x-www-form-urlencoded',
                  }
              }).then(res => res.json())
              .then(result => {
                  // const entities = formatSearchResult(result).flat();
                  // handleSearchMatchChange(entities);
                  return result;
              });
  };

const getConferenceContent = async () => {
// load all the publication list from CHI 2022
const pub_link=`https://files.sigchi.org/conference/program/CHI/2022`; // ID: 10072

return fetch(pub_link).then((data) => data.json()).then((result)=>{return result['contents']});
// .then(result => {
//     console.log(result)
//     result['contents']
// })

// return result['contents'];
};

export default fetchLikedContent;
export {conf_ID, getConferenceContent};